module.exports = __webpack_public_path__ + "static/media/banner-placeholder.15ad7ae1.png";